export default __webpack_public_path__ + "static/media/fuel_truck.4a19c0c5.png";